import { lazy } from "react";
import { Link } from "react-router";
import LogoutIcon from "@/components/icons/logout.icon";
import SettingIcon from "@/components/icons/setting.icon";
import useBusiness from "@/hooks/business.hook";
import useHotel from "@/hooks/hotel.hook";
import useRestaurant from "@/hooks/restaurant.hook";
import { useAppDispatch } from "@/store/hooks";
import { signOut } from "@/store/slicers/auth.slicer";

const CurrentHotelFilter = lazy(() => import("@/components/current-hotel-filter.component"));
const CurrentRestaurantFilter = lazy(() => import("@/components/current-restaurant-filter.component"));

const Navbar = () => {
  const { restaurants } = useRestaurant();
  const { hotels } = useHotel();
  const { business } = useBusiness();
  const dispatch = useAppDispatch();

  return (
    <div className="flex-none h-14 flex items-center justify-between px-8 border-b border-teal-900/20">
      <div>
        <span className="font-bold text-teal-950">{business?.name}</span>
      </div>
      <div className="flex gap-4">
        {restaurants.length > 0 && <CurrentRestaurantFilter />}
        {hotels.length > 0 && <CurrentHotelFilter />}
        <Link to="/dashboard/settings" className="flex cursor-pointer hover:bg-teal-900/20 rounded-lg p-2 group transition-all">
          <SettingIcon className="size-5 group-hover:text-white transition-all" />
        </Link>
        <button
          type="button"
          className="flex cursor-pointer hover:bg-teal-900/20 rounded-lg p-2 group transition-all"
          onClick={() => dispatch(signOut())}
        >
          <LogoutIcon size="size-5 group-hover:text-white transition-all" />
        </button>
      </div>
    </div>
  );
};
export default Navbar;
